module.exports = __webpack_public_path__ + "ug.svg?e3a4cfeeb3082c18bf132dfa9e8df10f";